var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RouterLink as Link } from '../Router/';

import "./ModuleLink.scss";

var ModuleLink = (_temp2 = _class = function (_Component) {
    _inherits(ModuleLink, _Component);

    function ModuleLink() {
        var _temp, _this, _ret;

        _classCallCheck(this, ModuleLink);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onClick = function (event) {
            if (!_this.props.onClick) {
                return false;
            }

            event.stopPropagation();

            _this.props.onClick();

            /*
            const { target } = event 
            
            console.log('target', event.target)
            console.log('className', event.target.className)
            
            if (target.className.startsWith("admin-module")) {
                this.props.onClick()
            }
            */
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ModuleLink.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            url = _props.url,
            onClick = _props.onClick;


        if (url) {
            return React.createElement(
                Link,
                { className: 'admin-module__link', to: url, onClick: function onClick(event) {
                        return _this2.onClick(event);
                    } },
                this.props.children
            );
        }

        if (onClick) {
            return React.createElement(
                'div',
                { className: 'admin-module__link', onClick: function onClick(event) {
                        return _this2.onClick(event);
                    } },
                this.props.children
            );
        }

        return this.props.children;
    };

    return ModuleLink;
}(Component), _class.defaultProps = {
    url: undefined
}, _temp2);


export default ModuleLink;